// Copyright (c) 2021, Elicenciamento. All rights reserved.

const overrides = {
  MuiCssBaseline: {
    "@global": {
      iframe: {
        border: 0,
      },
      ".MuiPaper-rounded": {
        borderRadius: "8px",
      },
      ".MuiAccordion-rounded:last-child": {
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px",
      },
      ".MuiAccordion-rounded:first-child": {
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
      },
    },
  },
};

export default overrides;
